<nz-spin [nzSpinning]="loading" *ngIf="!isEditing && clickToEdit" (click)="startEditing()" class="click-to-edit-area">
    <div *ngIf="displayValue; else resourceTemplate">
        <span class="resource-list">{{ displayValue }}</span>
    </div>
    <ng-template #resourceTemplate>
        Add Resources
    </ng-template>
</nz-spin>

<ng-container *ngIf="isEditing || !clickToEdit">
    <nz-spin [nzSpinning]="loading">
        <nz-tree-select
            #treeSelect
            style="width: 100%"
            [nzDropdownClassName]="'resource-tree-dropdown'"
            class="resource-tree-select"
            [nzNodes]="nodes"
            [(ngModel)]="data"
            [nzCheckStrictly]="true"
            (ngModelChange)="changeSelect($event)"
            nzShowSearch
            nzCheckable
            nzPlaceHolder="Please select"
            [nzDropdownMatchSelectWidth]="true"
        >
        </nz-tree-select>
    </nz-spin>
    <div class="action-group" *ngIf="!formControlName">
        <button nz-button nzType="primary" class="action-item" (click)="handleSave()" [nzLoading]="saveLoading">Save</button>
        <button nz-button  nzDanger class="action-item" (click)="handleCancel()">Cancel</button>
    </div>
</ng-container>
